import React from 'react'
import CircleRightTop from "../images/EllipseTeamTopLeft.png";
import CircleLeftBottom from "../images/EllipseRightBottom.png";
import TeamHero from "../images/teamhero.png";
import { useTranslation } from 'react-i18next';

const AboutHeroSection = () => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="login__section mt-[80px] md:mt-[90px] lg:mt-[50px] 2xl:mt-[90px]">
                <img draggable="false" src={CircleRightTop} className="back_circle1" alt="back_circle1" />
                <img draggable="false" src={CircleLeftBottom} className="back_circle2" alt="back_circle2" />
                <div className="container mx-auto px-2 pb-5 md:pb-0 xl:max-w-[1000px] 3xl:max-w-[1400px] text-center sm:text-start">
                    <div className="container grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-[0%] lg:gap-[0%]  sm:my-[30px] md:my-[40px] lg:my-[40px]">
                        <div className='flex items-center justify-between'>
                            <div className='mb-5'>
                                <div className="pb-5">
                                    <button className="sora font-[600] px-2 sm:px-4 py-1 text-[14px] sm:text-[16px] sm:py-2 text-[#3359D3] border border-opacity-40 border-[#3359D3] rounded-[38px]">
                                        {t("team")}
                                    </button>
                                </div>
                                <h1 className="text-[30px] sm:text-[34px] leading-[45px] sm:leading-[50px] md:leading-[58px] 3xl:leading-[80px] md:text-[36px] 3xl:text-[51px] font-[700] text-[#141619] capitalize">
                                    {t("we_are_vitta")}
                                </h1>
                                <h1 className="text-[30px] sm:text-[34px] leading-[45px] sm:leading-[50px] md:leading-[58px] 3xl:leading-[80px] md:text-[36px] 3xl:text-[51px] font-[700] text-[#141619] capitalize">
                                    {("technology")}
                                </h1>
                                {/* <h1
                        className="text-[22px] sm:text-[40px] leading-[40px] sm:leading-[50px] md:leading-[60px]  3xl:leading-[90px] md:text-[50px]   3xl:text-[80px] font-[800] bg-gradient-to-r from-blue-600 via-purple-600 to-purple-900 text-transparent bg-clip-text"
                    >
                        Web3 Security!
                    </h1> */}
                                <h1 className="sora text-[#141619] md:text-[14px] lg:text-[13px] xl:text-[13px] text-[16px] sm:text-[16px] 3xl:text-[19px] font-[400] pt-3 mt-[15px]">
                                    {t("team_subtitle")}
                                </h1>
                            </div>
                        </div>
                        <div className="flex justify-center">
                            <img draggable="false"
                                src={TeamHero}
                                className="sm:h-[350px] sm:w-[400px] lg:h-[390px] md:w-[390px] rounded-[10px] object-contain"
                                alt="heroimage"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AboutHeroSection